"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CellBooleanRenderer = CellBooleanRenderer;
exports.CellDateRenderer = CellDateRenderer;
exports.CellEditRenderer = CellEditRenderer;
exports.CellNotesRenderer = CellNotesRenderer;
exports.CellTextRenderer = CellTextRenderer;
exports.cellDateFormatter = void 0;
exports.default = CellRenderer;
var _iconsMaterial = require("@mui/icons-material");
var _material = require("@mui/material");
var _react = _interopRequireDefault(require("react"));
var _styles = require("@mui/styles");
var _utils = require("../../utils");
const useStyles = (0, _styles.makeStyles)(theme => ({
  editIcon: {
    marginLeft: theme.spacing(1)
  },
  textRoot: {
    maxWidth: 400
  },
  date: {
    whiteSpace: 'nowrap'
  },
  default: {
    '&.MuiTableCell-root': {
      height: '52px',
      paddingTop: '0px',
      paddingBottom: '0px',
      borderBottom: "1px solid ".concat(theme.palette.TwClrBrdrSecondary),
      fontVariantNumeric: 'tabular-nums'
    }
  }
}));
function CellRenderer(props) {
  const {
    column,
    value,
    onRowClick,
    index,
    className,
    booleanFalseText,
    booleanTrueText,
    editText
  } = props;
  const id = "row".concat(index, "-").concat(column.key);
  if (column.type === 'date' && typeof value === 'string' && value) {
    return /*#__PURE__*/_react.default.createElement(CellDateRenderer, {
      id: id,
      value: value,
      className: className,
      alignment: column.alignment
    });
  } else if (column.type === 'notes' && value && typeof value === 'string') {
    return /*#__PURE__*/_react.default.createElement(CellNotesRenderer, {
      id: id,
      value: value,
      className: className,
      alignment: column.alignment
    });
  } else if (column.type === 'boolean') {
    return /*#__PURE__*/_react.default.createElement(CellBooleanRenderer, {
      id: id,
      value: value,
      className: className,
      booleanFalseText: booleanFalseText,
      booleanTrueText: booleanTrueText,
      alignment: column.alignment
    });
  } else if (column.type === 'edit') {
    return /*#__PURE__*/_react.default.createElement(CellEditRenderer, {
      id: id,
      onRowClick: onRowClick,
      className: className,
      editText: editText,
      alignment: column.alignment
    });
  }
  return /*#__PURE__*/_react.default.createElement(CellTextRenderer, {
    id: id,
    value: value,
    className: className,
    alignment: column.alignment
  });
}
const cellDateFormatter = value => {
  if (value) {
    return (0, _utils.getDateDisplayValue)(value);
  }
};
exports.cellDateFormatter = cellDateFormatter;
function CellDateRenderer(_ref) {
  let {
    id,
    value,
    className,
    alignment
  } = _ref;
  const classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_material.TableCell, {
    id: id,
    align: alignment || 'left',
    className: "".concat(classes.date, " ").concat(classes.default, " ").concat(className)
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    component: "p",
    variant: "body1",
    fontSize: "14px"
  }, cellDateFormatter(value)));
}
function CellTextRenderer(_ref2) {
  let {
    id,
    value,
    className,
    alignment
  } = _ref2;
  const classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_material.TableCell, {
    id: id,
    align: alignment || 'left',
    title: typeof value === 'string' ? value : '',
    className: "".concat(classes.default, " ").concat(className)
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    component: "p",
    variant: "body1",
    noWrap: true,
    classes: {
      root: classes.textRoot
    },
    fontSize: "14px"
  }, value));
}
function CellBooleanRenderer(_ref3) {
  let {
    id,
    value,
    className,
    booleanFalseText,
    booleanTrueText,
    alignment
  } = _ref3;
  const classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_material.TableCell, {
    id: id,
    align: alignment || 'left',
    className: "".concat(classes.default, " ").concat(className)
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    component: "p",
    variant: "body1",
    fontSize: "14px"
  }, (value === null || value === void 0 ? void 0 : value.toString()) === 'true' ? booleanTrueText : booleanFalseText));
}
function CellNotesRenderer(_ref4) {
  let {
    id,
    value,
    className,
    alignment
  } = _ref4;
  const classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_material.TableCell, {
    id: id,
    align: alignment || 'left',
    className: "".concat(classes.default, " ").concat(className)
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    id: id,
    component: "p",
    variant: "body1",
    fontSize: "14px"
  }, value && value.length > 0 ? /*#__PURE__*/_react.default.createElement(_iconsMaterial.Notes, null) : ''));
}
function CellEditRenderer(_ref5) {
  let {
    id,
    onRowClick,
    className,
    editText,
    alignment
  } = _ref5;
  const classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_material.TableCell, {
    id: id,
    align: alignment || 'left',
    className: "".concat(classes.default, " ").concat(className)
  }, /*#__PURE__*/_react.default.createElement(_material.Link, {
    id: "".concat(id, "-button"),
    href: "#",
    onClick: event => {
      (0, _utils.preventDefaultEvent)(event);
      if (onRowClick) {
        onRowClick();
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex"
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    component: "p",
    variant: "body1",
    fontSize: "14px"
  }, editText), /*#__PURE__*/_react.default.createElement(_iconsMaterial.Edit, {
    fontSize: "small",
    className: classes.editIcon
  }))));
}